export enum TravelBookingType {
  FLIGHTS = 'FLIGHTS',
  FLIGHTS_BY_SECTOR = 'FLIGHTS_BY_SECTOR',
  BUSES = 'BUSES',
  HOTELS = 'HOTELS',
  PACKAGE_AIR = 'PACKAGE_AIR',
  AUTOS = 'AUTOS',
  ACTIVITIES = 'ACTIVITIES'
}
